import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatTreeFlatDataSource, MatTreeFlattener, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Tela } from 'src/app/models/perfil';
import { Relatorio } from 'src/app/models/relatorios';
import { TodoItemFlatNode } from 'src/app/models/to-do-item-flat-node';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PerfilService } from 'src/app/services/perfil.service';

@Component({
  selector: 'app-telas-modal',
  templateUrl: './telas-modal.component.html',
  styleUrls: ['./telas-modal.component.scss']
})
export class TelasModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  telas: Number[] = [];
  relatorios: Number[] = [];
  telasDosPerfis: Number[] = [];
  relatoriosDosPerfis: Number[] = [];

  // treeview
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TodoItemFlatNode, Tela>();
  flatNodeMapRelatorio = new Map<TodoItemFlatNode, Relatorio>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<Tela, TodoItemFlatNode>();
  nestedNodeMapRelatorio = new Map<Relatorio, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeControlRelatorio: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<Tela, TodoItemFlatNode>;
  treeFlattenerRelatorio: MatTreeFlattener<Relatorio, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<Tela, TodoItemFlatNode>;
  dataSourceRelatorio: MatTreeFlatDataSource<Relatorio, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  checklistSelectionRelatorio = new SelectionModel<TodoItemFlatNode>(true /* multiple */);

  constructor(public dialogRef: MatDialogRef<TelasModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private perfilService: PerfilService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeFlattenerRelatorio = new MatTreeFlattener(this.transformerRelatorio, this.getLevel, this.isExpandable, this.getChildrenRelatorio);

    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.treeControlRelatorio = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);

    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSourceRelatorio = new MatTreeFlatDataSource(this.treeControlRelatorio, this.treeFlattenerRelatorio);

    this.dataSource.data = [];
    this.dataSourceRelatorio.data = [];
  }

  ngOnInit() {
    this.telas = this.data.telas;
    this.relatorios = this.data.relatorios;
    this.telasDosPerfis = this.data.telasDosPerfis;
    this.relatoriosDosPerfis = this.data.relatoriosDosPerfis;

    this.buscarTelas();
    this.buscarRelatorios();
  }

  buscarTelas() {
    this.carregandoService.mostra('buscarTelas');

    this.perfilService.consultarTelas().subscribe(telas => {
      this.dataSource.data = telas;

      this.treeControl.dataNodes.forEach(p => {
        if (p.tipo === 1 && this.telas.some(t => t === p.id)) {
          this.checklistSelection.select(p);
        }

        if (p.tipo === 1 && this.telasDosPerfis.some(t => t === p.id)) {
          p.jaTemAcesso = true;
        }
      });

      this.carregandoService.esconde('buscarTelas');
    }, (erro) => {
      this.carregandoService.esconde('buscarTelas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarRelatorios() {
    this.carregandoService.mostra('buscarRelatorios');
    this.perfilService.consultarRelatorios().subscribe(rel => {
      this.dataSourceRelatorio.data = rel;

      this.treeControlRelatorio.dataNodes.forEach(p => {
        if (this.relatorios != null && this.relatorios != undefined && this.relatorios.some(t => t === p.id)) {
          this.checklistSelectionRelatorio.select(p);
        }

        if (this.relatoriosDosPerfis !== undefined && this.relatoriosDosPerfis !== null && this.relatoriosDosPerfis.some(t => t === p.id)) {
          p.jaTemAcesso = true;
        }
      });

      this.carregandoService.esconde('buscarRelatorios');
    }, (erro) => {
      this.carregandoService.esconde('buscarRelatorios');
      this.notificacaoService.erro(erro);
    });
  }

  selecionar() {
    const telasSelecionadas: Number[] = [];
    const relatoriosSelecionados: Number[] = [];

    this.checklistSelection.selected.forEach(p => {
      if (p.tipo === 1) {

        if (!telasSelecionadas.some(t => t === p.id)) {
          telasSelecionadas.push(p.id);
        }
        if (p.idPai !== null && !telasSelecionadas.some(t => t === p.idPai)) {
          telasSelecionadas.push(p.idPai);
        }
      }
    });

    this.checklistSelectionRelatorio.selected.forEach(p => {
      if (!relatoriosSelecionados.some(t => t === p.id)) {
        relatoriosSelecionados.push(p.id);
      }

      if (p.idPai !== null && !relatoriosSelecionados.some(t => t === p.idPai)) {
        relatoriosSelecionados.push(p.idPai);
      }
    });

    const resultado = {
      telas: telasSelecionadas,
      relatorios: relatoriosSelecionados
    }

    this.dialogRef.close(resultado);
  }

  fechar() {
    this.dialogRef.close();
  }

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: Tela): Tela[] => node.filhos;
  getChildrenRelatorio = (node: Relatorio): Relatorio[] => node.filhos;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.descricao === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: Tela, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.id === node.id && existingNode.tipo === node.tipo
      ? existingNode
      : new TodoItemFlatNode();
    flatNode.id = node.id;
    flatNode.descricao = node.descricao;
    flatNode.tipo = node.tipo;
    flatNode.idPai = node.idPai;
    flatNode.level = level;
    flatNode.expandable = node.filhos && node.filhos.length > 0; //!!node.children?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  transformerRelatorio = (node: Relatorio, level: number) => {
    const existingNode = this.nestedNodeMapRelatorio.get(node);
    const flatNode = existingNode && existingNode.id === node.id && existingNode.tipo === node.tipo
      ? existingNode
      : new TodoItemFlatNode();
    flatNode.id = node.id;
    flatNode.descricao = node.descricao;
    flatNode.tipo = node.tipo;
    flatNode.idPai = node.idPai;
    flatNode.level = level;
    flatNode.expandable = node.filhos && node.filhos.length > 0; //!!node.children?.length;
    this.flatNodeMapRelatorio.set(flatNode, node);
    this.nestedNodeMapRelatorio.set(node, flatNode);
    return flatNode;
  };

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    return descAllSelected;
  }

  descendantsAllSelectedRelatorio(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControlRelatorio.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelectionRelatorio.isSelected(child);
    });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  descendantsPartiallySelectedRelatorio(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControlRelatorio.getDescendants(node);
    const result = descendants.some(child => this.checklistSelectionRelatorio.isSelected(child));
    return result && !this.descendantsAllSelectedRelatorio(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  todoItemSelectionToggleRelatorio(node: TodoItemFlatNode): void {
    this.checklistSelectionRelatorio.toggle(node);
    const descendants = this.treeControlRelatorio.getDescendants(node);
    this.checklistSelectionRelatorio.isSelected(node)
      ? this.checklistSelectionRelatorio.select(...descendants)
      : this.checklistSelectionRelatorio.deselect(...descendants);

    descendants.forEach(child => this.checklistSelectionRelatorio.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  todoLeafItemSelectionToggleRelatorio(node: TodoItemFlatNode): void {
    this.checklistSelectionRelatorio.toggle(node);
    this.checkAllParentsSelectionRelatorio(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  checkAllParentsSelectionRelatorio(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelectionRelatorio(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  checkRootNodeSelectionRelatorio(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelectionRelatorio.isSelected(node);
    const descendants = this.treeControlRelatorio.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelectionRelatorio.isSelected(child);
    });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelectionRelatorio.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelectionRelatorio.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

}
